import { supabase } from '../lib/supabase';

export type NotificationType =
  | 'ticket_created'
  | 'ticket_status'
  | 'document_sent'
  | 'document_signed'
  | 'new_message';

export async function createNotification(
  userId: string,
  type: NotificationType,
  title: string,
  body: string,
  href?: string
) {
  await supabase.from('notifications').insert({
    user_id: userId,
    type,
    title,
    body,
    href: href ?? null,
  });
}
